[
  {
    "from": " ",
    "to": "-"
  },
  {
    "from": "/",
    "to": "-"
  },
  {
    "from": "%",
    "to": "-"
  },
  {
    "from": "&",
    "to": "-"
  },
  {
    "from": "|",
    "to": "-"
  },
  {
    "from": "ü",
    "to": "ue"
  },
  {
    "from": "ö",
    "to": "oe"
  },
  {
    "from": "ä",
    "to": "ae"
  },
  {
    "from": "ß",
    "to": "ss"
  },
  {
    "from": "é",
    "to": "e"
  },
  {
    "from": "è",
    "to": "e"
  },
  {
    "from": "ê",
    "to": "e"
  },
  {
    "from": "à",
    "to": "a"
  },
  {
    "from": "ñ",
    "to": "n"
  },
  {
    "from": "?",
    "to": ""
  },
  {
    "from": "(",
    "to": ""
  },
  {
    "from": ")",
    "to": ""
  },
  {
    "from": ":",
    "to": ""
  },
  {
    "from": "+",
    "to": "plus"
  }
]